module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-tabs', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed-tabs": "",
      "grow": "",
      "height": "40"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _vm._l((_vm.tabitems), function(tabitem) {
    return _c('v-tab', {
      key: tabitem
    }, [_vm._v("\n      " + _vm._s(tabitem) + "\n    ")])
  })], 2), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 0
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-form', {
    ref: "frmPersonal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "20px"
    }
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": 120
    }
  }, [(_vm.avatarURL) ? _c('img', {
    attrs: {
      "src": _vm.avatarURL
    }
  }) : _c('v-icon', {
    attrs: {
      "color": "grey",
      "size": "110px"
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.loadAvatarFromFile
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickAvatar
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.prepareCamera
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("photo_camera")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-2"
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.cust_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "cust_name", $$v)
      },
      expression: "profile.cust_name"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Gender",
      "items": ['Male', 'Female'],
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.profile.gender),
      callback: function($$v) {
        _vm.$set(_vm.profile, "gender", $$v)
      },
      expression: "profile.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('vue-tel-input-vuetify', {
    ref: "refMob",
    attrs: {
      "label": "Mobile number",
      "placeholder": "Enter a mobile number",
      "rules": [_vm.rules.required],
      "input-options": {
        showDialCode: true
      }
    },
    on: {
      "input": _vm.keepCursor,
      "validate": _vm.validateMob
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.ignoreBackspace.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.profile.contact_phone),
      callback: function($$v) {
        _vm.$set(_vm.profile, "contact_phone", $$v)
      },
      expression: "profile.contact_phone"
    }
  })], 1), _vm._v(" "), (_vm.config.MOBILE_NO !== this.profile.contact_phone) ? _c('v-flex', {
    staticClass: "warning px-2 pt-2 mb-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "caption",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("Mobile number change deducted. Press send OTP after changing the number to get it validated.")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "type": "number",
      "placeholder": "Enter OTP",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.otp),
      callback: function($$v) {
        _vm.otp = $$v
      },
      expression: "otp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    staticClass: "mt-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.sendOTP
    }
  }, [_vm._v("Send OTP")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.config.MOBILE_NO !== this.profile.contact_phone) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "rules": [_vm.rules.required, _vm.rules.email],
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.contact_email),
      callback: function($$v) {
        _vm.$set(_vm.profile, "contact_email", $$v)
      },
      expression: "profile.contact_email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "mt-0 py-0 mb-3",
    attrs: {
      "disabled": _vm.isMC || _vm.isFM,
      "label": "Hide contact info from others",
      "hint": "Not possible if you are a MC member or FM ;)",
      "persistent-hint": "",
      "outline": ""
    },
    model: {
      value: (_vm.hideContact),
      callback: function($$v) {
        _vm.hideContact = $$v
      },
      expression: "hideContact"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Other Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Emergency phone",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.emergency_phone),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_phone", $$v)
      },
      expression: "profile.emergency_phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Contact name",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.emergency_contact_name),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_contact_name", $$v)
      },
      expression: "profile.emergency_contact_name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Contact relationship",
      "items": ['Spouse', 'Father', 'Mother', 'Son', 'Daughter'],
      "maxlength": "15",
      "hide-details": ""
    },
    model: {
      value: (_vm.profile.emergency_contact_relation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "emergency_contact_relation", $$v)
      },
      expression: "profile.emergency_contact_relation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Blood group",
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.profile.blood_group),
      callback: function($$v) {
        _vm.$set(_vm.profile, "blood_group", $$v)
      },
      expression: "profile.blood_group"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Occupation",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.occupation),
      callback: function($$v) {
        _vm.$set(_vm.profile, "occupation", $$v)
      },
      expression: "profile.occupation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Hobbies",
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.hobbies),
      callback: function($$v) {
        _vm.$set(_vm.profile, "hobbies", $$v)
      },
      expression: "profile.hobbies"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Address")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Address",
      "hide-details": "",
      "maxlength": "150"
    },
    model: {
      value: (_vm.profile.address),
      callback: function($$v) {
        _vm.$set(_vm.profile, "address", $$v)
      },
      expression: "profile.address"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "City",
      "hide-details": "",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.city),
      callback: function($$v) {
        _vm.$set(_vm.profile, "city", $$v)
      },
      expression: "profile.city"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.config.COMM_COUNTRY_CODE === 'MY' ? 'Postal Code' : 'PIN Code',
      "hide-details": "",
      "maxlength": "10"
    },
    model: {
      value: (_vm.profile.pin_code),
      callback: function($$v) {
        _vm.$set(_vm.profile, "pin_code", $$v)
      },
      expression: "profile.pin_code"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "State",
      "maxlength": "25"
    },
    model: {
      value: (_vm.profile.state),
      callback: function($$v) {
        _vm.$set(_vm.profile, "state", $$v)
      },
      expression: "profile.state"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Country",
      "maxlength": "50"
    },
    model: {
      value: (_vm.profile.country),
      callback: function($$v) {
        _vm.$set(_vm.profile, "country", $$v)
      },
      expression: "profile.country"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.config.IS_TAX_APP) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("Tax Information")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "GST Identification No.",
      "hide-details": "",
      "maxlength": "15"
    },
    model: {
      value: (_vm.profile.gst_no),
      callback: function($$v) {
        _vm.$set(_vm.profile, "gst_no", $$v)
      },
      expression: "profile.gst_no"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMC || _vm.isAdmin) ? _c('div', {
    staticClass: "mt-3 mx-auto"
  }, [(_vm.isMC) ? _c('v-chip', {
    attrs: {
      "color": "primary white--text",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("star")]), _vm._v(_vm._s(_vm.roleName))], 1) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('v-chip', {
    attrs: {
      "color": "primary white--text",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("supervisor_account")]), _vm._v("Admin")], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    nativeOn: {
      "click": function($event) {
        _vm.canSendOTP = false, _vm.cancelChanges()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 1
  }, [_c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "frmUnit",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, _vm._l((_vm.config.UNITS), function(unit, i) {
    return _c('v-card', {
      key: i,
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "primary lighten-2"
    }, [_c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "grid-list-md": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "white--text title",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.commName) + "\n                      ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "yellow--text subheading",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                        " + _vm._s(unit.block_nm + ' ' + unit.unit_no) + " "), (unit.bhk || unit.acc_sqft) ? _c('span', [_vm._v("- "), (unit.bhk) ? _c('span', [_vm._v(_vm._s(unit.bhk) + " BHK, ")]) : _vm._e(), (unit.acc_sqft) ? _c('span', [_vm._v(_vm._s(unit.acc_sqft) + " sqft ")]) : _vm._e()]) : _vm._e(), _vm._v("(" + _vm._s(unit.ownership) + ")\n                      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('v-switch', {
      staticClass: "ma-0",
      attrs: {
        "label": "Rented out",
        "hide-details": "",
        "disabled": unit.ownership.toLowerCase().includes('tenant')
      },
      on: {
        "change": function($event) {
          return _vm.saveChanges(unit, true)
        }
      },
      model: {
        value: (unit.is_rented),
        callback: function($$v) {
          _vm.$set(unit, "is_rented", $$v)
        },
        expression: "unit.is_rented"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [_c('v-switch', {
      staticClass: "ma-0",
      attrs: {
        "label": 'Bill to tenant' + (_vm.users[unit.unit_id] && _vm.users[unit.unit_id].findIndex(function (rec) { return rec.ownership.toLowerCase().includes('tenant'); }) === -1 && unit.is_rented ? ' (No tenant info available)' : ''),
        "hide-details": "",
        "disabled": unit.ownership.toLowerCase().includes('tenant') || (_vm.users[unit.unit_id] && _vm.users[unit.unit_id].findIndex(function (rec) { return rec.ownership.toLowerCase().includes('tenant'); }) === -1 || !unit.is_rented)
      },
      on: {
        "change": function($event) {
          return _vm.saveChanges(unit)
        }
      },
      model: {
        value: (unit.is_billed_to_tenant),
        callback: function($$v) {
          _vm.$set(unit, "is_billed_to_tenant", $$v)
        },
        expression: "unit.is_billed_to_tenant"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
      staticClass: "ma-2"
    }, [_c('v-card-title', {
      staticClass: "pa-2 grey lighten-4"
    }, [_c('div', {
      staticClass: "title grey--text"
    }, [_vm._v("Integra users from this unit")])]), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.userHeadSm : _vm.userHead,
        "items": _vm.users[unit.unit_id],
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_c('v-avatar', {
            attrs: {
              "slot": "activator",
              "size": "36px"
            },
            slot: "activator"
          }, [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.avatar_url
            }
          })])], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(props.item.cust_name) + "\n                    ")]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.contact_phone))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(props.item.ownership) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(!props.item.is_active ? 'Disabled' : props.item.rel_status) + "\n                    ")]), _vm._v(" "), (!unit.ownership.toLowerCase().includes('tenant')) ? _c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "left": ""
            }
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', [(props.item.rel_status === 'Pending Approval' || props.item.rel_status === 'Rejected') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.acceptRejReq('accept-req', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("check")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Approve request")])], 1) : _vm._e(), _vm._v(" "), (props.item.rel_status === 'Pending Approval') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.acceptRejReq('reject-req', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Reject request")])], 1) : _vm._e(), _vm._v(" "), (props.item.rel_status === 'Linked') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.userUpdate('delink', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delink from this unit")])], 1) : (props.item.rel_status === 'Delinked') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.userUpdate('link', props.item, unit)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("link")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Link to this unit")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)]
        }
      }], null, true)
    })], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 2
  }, [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [(_vm.lAction == 'view') ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.vehHeadSm : _vm.vehHead,
      "items": _vm.vehicles,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.updateVeh(props.item)
            }
          }
        }, [(_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.block_nm + ' ' + props.item.unit_no))]) : _vm._e(), _vm._v(" "), _c('td', [_c('v-icon', [_vm._v(_vm._s(props.item.veh_type === 'Car' ? 'directions_car' : 'directions_bike'))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.veh_no))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.has_got_sticker ? 'Yes' : 'No'))])])]
      }
    }], null, false, 1971337146)
  }) : _vm._e(), _vm._v(" "), (_vm.lAction != 'view') ? _c('v-form', {
    ref: "frmVeh",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateAndSave()
      }
    }
  }, [(_vm.lAction) ? _c('v-card', {
    staticClass: "mt-2"
  }, [(_vm.lAction === 'create') ? _c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Create Vehicle")]) : _vm._e(), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Vehicle Details")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.config.USER_HAS_MORE_UNITS) ? _c('v-select', {
    attrs: {
      "label": "Unit",
      "items": _vm.config.UNITS,
      "item-text": "block_and_unit",
      "item-value": "unit_id",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.vehicle.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "unit_id", $$v)
      },
      expression: "vehicle.unit_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.vehicleTypes,
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.vehicle.veh_type),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "veh_type", $$v)
      },
      expression: "vehicle.veh_type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Number",
      "rules": [_vm.rules.required],
      "maxlength": "15"
    },
    model: {
      value: (_vm.vehicle.veh_no),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "veh_no", $$v)
      },
      expression: "vehicle.veh_no"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Has got parking sticker"
    },
    model: {
      value: (_vm.vehicle.has_got_sticker),
      callback: function($$v) {
        _vm.$set(_vm.vehicle, "has_got_sticker", $$v)
      },
      expression: "vehicle.has_got_sticker"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancelVeh.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteVeh.apply(null, arguments)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-alert', {
    staticClass: "mt-5",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Your declaration helps! How?")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-3"
  }, [_c('li', [_vm._v("For better & seamless security checks")]), _vm._v(" "), _c('li', [_vm._v("Hasle-free parking management")])])])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.config.IS_OTHER_USER) ? _c('v-tab-item', {
    key: 3
  }, [_c('v-container', {
    staticClass: "pa-2",
    attrs: {
      "grid-list-md": ""
    }
  }, [(_vm.dailyHelpAction == 'view') ? _c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.dhHeadSm : _vm.dhHead,
      "items": _vm.myDailyHelps,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.viewDailyHelp(props.item)
            }
          }
        }, [_c('td', [_c('v-avatar', {
          staticClass: "my-1",
          attrs: {
            "slot": "activator",
            "size": "45px"
          },
          slot: "activator"
        }, [_c('img', {
          attrs: {
            "src": _vm.config.STATIC_FILES_DIR + props.item.visitor_img_url
          }
        })])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.visitor_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.visitor_phone))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.visitor_sub_cat))]) : _vm._e()])]
      }
    }], null, false, 2113418656)
  }), _vm._v(" "), _c('v-alert', {
    staticClass: "mt-5 pa-2",
    attrs: {
      "outline": "",
      "color": "info",
      "value": true
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "color": "transparent"
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("Daily helpers of your unit!")]), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-3"
  }, [_c('li', [_vm._v("List is updated when security guard adds/deletes a helper behalf your unit")]), _vm._v(" "), _c('li', [_vm._v("Don't forget to report/delete when your helper no more works for you")]), _vm._v(" "), _c('li', [_vm._v("\n                Employing a maid? Click on + button and pick the one from list\n              ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Get notified when your helper checks in/out at gate")]), _vm._v(" "), _c('li', [_vm._v("For better & seamless security checks")])])])])], 1)], 1)], 1)], 1) : _c('v-layout', [_c('v-flex', {
    staticClass: "mx-auto",
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm3": ""
    }
  }, [_c('v-card-title', {
    staticClass: "px-0 pt-0 pb-1 title"
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.dailyHelpAction = 'view'
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v("\n        Add Daily Helper\n      ")], 1), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.dailyHelpList.stats), function(item, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      scopedSlots: _vm._u([{
        key: "header",
        fn: function() {
          return [_c('div', {
            staticClass: "title"
          }, [_c('b', [_vm._v(_vm._s(item.visitor_sub_cat) + " (" + _vm._s(item.tot_rec) + ")")])])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((_vm.dailyHelpList.detail.filter(function (rec) { return rec.visitor_sub_cat === item.visitor_sub_cat; })), function(helper, d) {
      return _c('div', [_c('v-card', {
        staticClass: "ma-2"
      }, [_c('v-card-text', {
        staticClass: "pb-2"
      }, [_c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs3": "",
          "sm2": "",
          "md1": ""
        }
      }, [_c('v-avatar', {
        staticClass: "mt-2 grey lighten-4",
        attrs: {
          "slot": "activator",
          "size": "65px"
        },
        slot: "activator"
      }, [_c('img', {
        attrs: {
          "src": _vm.config.STATIC_FILES_DIR + helper.visitor_img_url
        }
      })])], 1), _vm._v(" "), _c('v-flex', {
        class: _vm.$vuetify.breakpoint.smAndUp ? 'pl-3' : '',
        attrs: {
          "xs7": "",
          "sm9": "",
          "md10": ""
        }
      }, [_c('div', {
        staticClass: "subheading"
      }, [_c('strong', [_vm._v(_vm._s(helper.visitor_name))])]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "caption info--text"
      }, [_vm._v(_vm._s(helper.visitor_sub_cat.toUpperCase()))]), _vm._v(" "), _c('v-chip', {
        staticClass: "caption black--text mx-0",
        attrs: {
          "small": "",
          "disabled": ""
        }
      }, [_vm._v("Works in " + _vm._s(helper.tot_linked_units) + " unit" + _vm._s(helper.tot_linked_units === 1 ? '' : 's'))])], 1), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        },
        on: {
          "click": function($event) {
            return _vm.showDailyHelpRating(false, helper)
          }
        }
      }, [_c('v-rating', {
        attrs: {
          "size": "20",
          "color": "warning",
          "background-color": "grey",
          "dense": "",
          "readonly": ""
        },
        model: {
          value: (helper.avg_overall_rating),
          callback: function($$v) {
            _vm.$set(helper, "avg_overall_rating", $$v)
          },
          expression: "helper.avg_overall_rating"
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "info--text caption"
      }, [_c('a', {
        staticClass: "mr-3"
      }, [_vm._v(_vm._s(helper.no_of_rating) + " rating" + _vm._s(_vm.lRatings.no_of_rating === 1 ? '' : 's'))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(helper.no_of_review) + " review" + _vm._s(helper.no_of_review === 1 ? '' : 's'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
        staticClass: "text-xs-right",
        attrs: {
          "xs2": "",
          "sm1": "",
          "md1": ""
        }
      }, [_c('v-btn', {
        staticClass: "mt-4 grey lighten-4",
        attrs: {
          "icon": ""
        }
      }, [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": 'tel:' + item.visitor_phone
        }
      }, [_c('v-icon', [_vm._v("phone")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), (_vm.myDailyHelps.length && _vm.myDailyHelps.findIndex(function (rec) { return rec.easypass_id === helper.easypass_id; }) >= 0) ? _c('div', {
        staticClass: "grey--text caption"
      }, [_vm._v("Already linked to your unit")]) : _c('v-btn', {
        attrs: {
          "small": "",
          "flat": ""
        },
        on: {
          "click": function($event) {
            return _vm.addDailyHelper(helper)
          }
        }
      }, [_vm._v("Add to my unit")])], 1)], 1)], 1)
    })], 2)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.tab === 2 && _vm.lAction === 'view') || (_vm.tab === 3 && _vm.dailyHelpAction === 'view')) ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        _vm.tab === 2 ? _vm.createVeh() : _vm.prepareAddDailyHelp()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.viewDailyHelpDlg),
      callback: function($$v) {
        _vm.viewDailyHelpDlg = $$v
      },
      expression: "viewDailyHelpDlg"
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-sm": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pa-0 grey lighten-4"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.viewDailyHelpDlg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-0 text-xs-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "title",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lDailyHelp.visitor_name) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                " + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + "\n              ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-avatar', {
    staticClass: "grey lighten-4",
    attrs: {
      "size": 120
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.config.STATIC_FILES_DIR + _vm.lDailyHelp.visitor_img_url
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-chip', {
    staticClass: "black--text",
    attrs: {
      "small": "",
      "disabled": true
    }
  }, [_vm._v("Works in " + _vm._s(_vm.lDailyHelp.tot_linked_units) + " unit" + _vm._s(_vm.lDailyHelp.tot_linked_units === 1 ? '' : 's'))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lRatings) ? _c('v-card', [_c('v-card-text', {
    staticClass: "pa-2",
    on: {
      "click": function($event) {
        return _vm.showDailyHelpRating(!_vm.lRatings.no_of_rating)
      }
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "30",
      "color": "warning",
      "background-color": "grey",
      "dense": "",
      "readonly": ""
    },
    model: {
      value: (_vm.lRatings.avg_overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_overall_rating", $$v)
      },
      expression: "lRatings.avg_overall_rating"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info--text caption"
  }, [_c('a', {
    staticClass: "mr-3"
  }, [_vm._v(_vm._s(_vm.lRatings.no_of_rating) + " rating" + _vm._s(_vm.lRatings.no_of_rating === 1 ? '' : 's'))]), _vm._v(" "), _c('a', [_vm._v(_vm._s(_vm.lRatings.no_of_review) + " review" + _vm._s(_vm.lRatings.no_of_review === 1 ? '' : 's'))])])], 1), _vm._v(" "), _c('div', [_c('v-btn', {
    staticClass: "caption grey--text",
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showDailyHelpRating(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.lRatings.myratings ? ('You rated on ' + _vm.handy.formatDate(_vm.lRatings.myratings.rated_on)) : (_vm.lRatings.no_of_rating ? '' : 'Be the first one. ') + 'Review now!')), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("edit")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.showRepDelDailyHelp()
      }
    }
  }, [_vm._v("Report/Delete")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400px"
    },
    model: {
      value: (_vm.rateDailyHelpDlg),
      callback: function($$v) {
        _vm.rateDailyHelpDlg = $$v
      },
      expression: "rateDailyHelpDlg"
    }
  }, [(_vm.beingRated && _vm.lRatings) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      My feedback for " + _vm._s(_vm.lDailyHelp.visitor_name) + "\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Overall satisfaction")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "overall_rating", $$v)
      },
      expression: "rDailyHelp.overall_rating"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Skillful")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.skill),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "skill", $$v)
      },
      expression: "rDailyHelp.skill"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Regular")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.regular),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "regular", $$v)
      },
      expression: "rDailyHelp.regular"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("So loyal")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.loyal),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "loyal", $$v)
      },
      expression: "rDailyHelp.loyal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Easy going person")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "dense": ""
    },
    model: {
      value: (_vm.rDailyHelp.easygoing),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "easygoing", $$v)
      },
      expression: "rDailyHelp.easygoing"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2 mb-3"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Review",
      "hide-actions": "",
      "rows": "3",
      "maxlength": "250",
      "counter": "250",
      "placeholder": "Optional",
      "hint": "Your review will be visible to others, not personal details",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.rDailyHelp.review),
      callback: function($$v) {
        _vm.$set(_vm.rDailyHelp, "review", $$v)
      },
      expression: "rDailyHelp.review"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.rateDailyHelpDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.rateDailyHelp()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1) : (_vm.lRatings) ? _c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v("\n      " + _vm._s(_vm.lDailyHelp.visitor_name) + " (" + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + ")\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.rateDailyHelpDlg = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Overall satisfaction")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_overall_rating),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_overall_rating", $$v)
      },
      expression: "lRatings.avg_overall_rating"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Skillful")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_skill),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_skill", $$v)
      },
      expression: "lRatings.avg_skill"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Regular")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_regular),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_regular", $$v)
      },
      expression: "lRatings.avg_regular"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("So loyal")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_loyal),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_loyal", $$v)
      },
      expression: "lRatings.avg_loyal"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-1",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Easy going person")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "25",
      "color": "warning",
      "background-color": "grey",
      "readonly": "",
      "dense": ""
    },
    model: {
      value: (_vm.lRatings.avg_easygoing),
      callback: function($$v) {
        _vm.$set(_vm.lRatings, "avg_easygoing", $$v)
      },
      expression: "lRatings.avg_easygoing"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-2 mb-3"
  }), _vm._v(" "), (_vm.lRatings.no_of_review) ? _c('v-flex', {
    staticClass: "subheading",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.lRatings.detail), function(rec, i) {
    return _c('div', {
      key: i
    }, [_c('span', {
      staticClass: "caption grey--text"
    }, [_vm._v("A review posted on " + _vm._s(_vm.handy.formatDate(rec.rated_on)) + "\n              "), _c('v-rating', {
      attrs: {
        "size": "15",
        "color": "accent",
        "background-color": "grey",
        "readonly": "",
        "dense": ""
      },
      model: {
        value: (rec.overall_rating),
        callback: function($$v) {
          _vm.$set(rec, "overall_rating", $$v)
        },
        expression: "rec.overall_rating"
      }
    })], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "title info--text"
    }, [_vm._v("\"")]), _c('i', [_vm._v(_vm._s(rec.review))]), _c('span', {
      staticClass: "title info--text"
    }, [_vm._v("\"")])]), _vm._v(" "), (i < _vm.lRatings.detail.length - 1) ? _c('v-divider', {
      staticClass: "mx-3 my-2"
    }) : _vm._e()], 1)
  }), 0) : _c('v-flex', {
    staticClass: "text-xs-center caption",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          No reviews yet!\n        ")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.repDailyHelpDlg),
      callback: function($$v) {
        _vm.repDailyHelpDlg = $$v
      },
      expression: "repDailyHelpDlg"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_vm._v(_vm._s(_vm.lDailyHelp.visitor_name) + " (" + _vm._s(_vm.lDailyHelp.visitor_sub_cat) + ")")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-radio-group', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: (_vm.lDailyHelp.rep_del_reason),
      callback: function($$v) {
        _vm.$set(_vm.lDailyHelp, "rep_del_reason", $$v)
      },
      expression: "lDailyHelp.rep_del_reason"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": 'Delete as ' + (_vm.lDailyHelp.gender === 'Female' ? 'she' : 'he') + ' does not work for us any more',
      "value": "D"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": 'Report & delete as ' + (_vm.lDailyHelp.gender === 'Female' ? 'she' : 'he') + ' is wrongly linked to our unit',
      "value": "R"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.repDailyHelpDlg = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.repDelDailyHelp()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "310px"
    },
    model: {
      value: (_vm.vdoDlg),
      callback: function($$v) {
        _vm.vdoDlg = $$v
      },
      expression: "vdoDlg"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('video', {
    staticStyle: {
      "width": "280px",
      "height": "210px"
    },
    attrs: {
      "id": "cam",
      "autoplay": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center pb-3 pt-0"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.capturePhoto
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("camera")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "10px"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "color": "grey",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.closeVdoDlg.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 4000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90d03e52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 920
// module chunks = 28